import { useLocalization } from '@ais-ui/locale-management';
import { EventsForm } from './EventsForm';
import { EventsFormValues } from './useEventsForm';
import { UseFormReturn } from 'react-hook-form';

interface SettingsEventsPageProps {
  form: UseFormReturn<EventsFormValues>;
}

export function SettingsEventsPage({ form }: SettingsEventsPageProps) {
  const { messages } = useLocalization();

  return (
    <div className="space-y-6">
      <EventsForm form={form} />
    </div>
  );
}
